import * as React from "react";
import { Progress } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useSteps } from "../../../../hooks/hooks/use-steps.js";
const ConfiguratorHeaderProgress = ({
  className,
  currentStepIndex,
  currentSubStepIndex,
  subStepsPerStep,
  totalSteps
}) => {
  const { configuratorId } = useSteps();
  const { getLabel } = useIntl();
  const modalAriaLabel = getLabel(`products.${configuratorId}.configurator.modalName`);
  const calculateProgressValue = () => {
    const VISUAL_OFFSET = 5;
    if (totalSteps <= 1) return 100;
    const percentagePerStep = 100 / (totalSteps - 1);
    const baseProgress = currentStepIndex * percentagePerStep;
    const subStepProgress = calculateSubStepProgress(percentagePerStep);
    let totalProgress = baseProgress + subStepProgress;
    if (currentStepIndex === 0) totalProgress += VISUAL_OFFSET;
    if (currentStepIndex === totalSteps - 1) totalProgress -= VISUAL_OFFSET;
    return Math.min(Math.max(totalProgress, 0), 100);
  };
  const calculateSubStepProgress = (percentagePerStep) => {
    const hasSubSteps = (subStepsPerStep[currentStepIndex] ?? 0) > 0;
    const isNavigatedToSubStep = currentSubStepIndex !== void 0;
    if (!isNavigatedToSubStep || !hasSubSteps) return 0;
    const subStepCount = subStepsPerStep[currentStepIndex] ?? 0;
    const percentagePerSubStep = percentagePerStep / (subStepCount + 1);
    return (currentSubStepIndex + 1) * percentagePerSubStep;
  };
  return /* @__PURE__ */ React.createElement(
    Progress,
    {
      "aria-label": modalAriaLabel,
      className,
      max: 100,
      showLabel: false,
      value: calculateProgressValue()
    }
  );
};
export {
  ConfiguratorHeaderProgress
};
//# sourceMappingURL=ConfiguratorHeaderProgress.js.map
